/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  accountsListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGet,
} from "../../funcs/accountsListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema,
};

export const tool$accountsListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGet:
  ToolDefinition<typeof args> = {
    name:
      "account-transactions-list-v2",
    description: `List transactions for an account

This endpoint is similar to the v2 transactions list endpoint.
This endpoint returns a list of all transactions that have a \`from_account\`,
\`to_account\`, or \`from_ledger\` matching the given account.
It also returns a "next_cursor" and "previous_cursor" if there are more pages
of results

### How is data retrieved for this endpoint?

Values from the endpoint are created by scraping the transactions from the
ledger canister (and associated archive canisters).

Original tool name: list-account-transactions-ledger-canister-id-accounts-id-transactions-get`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await accountsListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };